<template>
    <div class="energyLabel">
        <div class="picto">
            <div class="d-flex align-items-center">
                <img
                    class="align-self-center my-1"
                    :alt="'terminal de classe énergétique ' + energyLabel.efficiencyClass"
                    :src="energyLabel.efficiencyClassImage"
                >
                <a
                    v-if="energyLabel.labelImage || energyLabel.sheetUrl"
                    class="ps-1"
                    :href="energyLabel.labelImage ? '#modal-energyLabel' : sheetHref"
                    :data-bs-toggle="energyLabel.labelImage ? 'modal' : ''"
                    :target="energyLabel.labelImage ? '' : '_blank'"
                    data-oevent-category="fiche_detail_equipement_conso"
                    :data-oevent-label="'indice_' + energyLabel.efficiencyClass"
                    :data-oevent-action="energyLabel.sheetUrl"
                >
                    <strong v-html="energyLabel.popinLinkLabel" />
                </a>
            </div>
        </div>
        <ob1-popin-modal2 :id="'modal-energyLabel'" :aria-labelledby="'modal-label-energyLabel'">
            <p :id="'modal-label-energyLabel'" class="h4" v-html="energyLabel.popinTitle" />
            <img
                alt=""
                class="w-50"
                :src="energyLabel.labelImage"
            >
            <ob1-liens
                v-if="energyLabel.sheetUrl"
                :with-arrow="true"
                :is-large="true"
                :text="energyLabel.sheetLinkLabel"
                :href="sheetHref"
                :target="'_blank'"
            />
        </ob1-popin-modal2>
    </div>
</template>

<script>
export default {
    name: "EnergyLabel",
    props: {
        energyLabel: {
            type: Object,
            required: true
        },
    },
    computed: {
        sheetHref: function() {
            return this.energyLabel.sheetUrl + '?webview_action=pdf'
        }
    }
};
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.picto {
    width: px-to-rem(250);
}
</style>
